export default [
  { key: "Node", text: "Node", value: "Node" },
    { key: "Station", text: "Station", value: "Station" }
];
